import React from 'react';
import Axios from "axios";
import 'moment/locale/fr'
import './addStyle.css';
import {useState, useEffect} from 'react';

function Home() {

    const [msgId , setMsgId] = useState("");
    const [msgSem , setMsgSem] = useState("");
    const [updated , setUpdated] = useState("");

    useEffect(() => {
        Axios.get('https://mlvoplanning.herokuapp.com/readmsg').then((response) => {
          setMsgSem(response.data[0].message);
          setMsgId(response.data[0]._id);
        })
    
      }, []);

    const handleMsg = (e) => {
        setMsgSem(e.target.value);
    }

    const updateMsg = (msg) => {

        msg.preventDefault();

        Axios.put
        (
            "https://mlvoplanning.herokuapp.com/updatemsg", 
            {
                id : msgId,
                message : msgSem,
            }
        )

        setUpdated("Message de la semaine mis à jour !");
    }
    

  return (

    <div>

        <form>
            <h2>ACCUEIL</h2>

            <label>Phrase de la semaine : </label>
            <div><input type="text" style={{width : "90%"}} value={msgSem} onChange={(e) => {handleMsg(e)}}></input></div>

            <div>
                <input
                    type = "submit"
                    value= "VALIDER"
                    className='sendBtn'
                    onClick={updateMsg}
                />
            </div>

            {updated ? updated : ""}

        </form>
      
    </div>
  );
}

export default Home;
